import React from 'react';
import PropTypes from 'prop-types';
const Thumbnail = _ref => {
  let src = _ref.src,
    style = _ref.style;
  return /*#__PURE__*/React.createElement("img", {
    className: "thumbnail",
    src: src,
    style: style,
    alt: "thumbnail"
  });
};
Thumbnail.propTypes = {
  src: PropTypes.string.isRequired,
  style: PropTypes.shape({
    width: PropTypes.string
  }).isRequired
};
export default Thumbnail;